"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var ARROW_UP = 'ArrowUp';
var ARROW_DOWN = 'ArrowDown';
var HOME = 'Home';
var END = 'End';

var useListSelectionKeyboardActions = function useListSelectionKeyboardActions(_ref) {
  var _ref$itemIds = _ref.itemIds,
      itemIds = _ref$itemIds === void 0 ? [] : _ref$itemIds,
      _ref$activeItemId = _ref.activeItemId,
      activeItemId = _ref$activeItemId === void 0 ? '' : _ref$activeItemId,
      callback = _ref.callback,
      _ref$cycle = _ref.cycle,
      cycle = _ref$cycle === void 0 ? false : _ref$cycle;
  var onKeyDown = (0, _react.useCallback)(function (event) {
    var totalIds = itemIds.length;

    if (!totalIds) {
      return;
    }

    var activeIdx = itemIds.indexOf(activeItemId);
    var newActiveIdx = activeIdx;

    switch (event.key) {
      case ARROW_UP:
        // Prevent page scroll
        event.preventDefault();

        if (!activeItemId) {
          newActiveIdx = totalIds - 1;
        } else {
          newActiveIdx = cycle ? (activeIdx - 1 + totalIds) % totalIds : Math.max(0, activeIdx - 1);
        }

        break;

      case ARROW_DOWN:
        // Prevent page scroll
        event.preventDefault();

        if (!activeItemId) {
          newActiveIdx = 0;
        } else {
          newActiveIdx = cycle ? (activeIdx + 1) % totalIds : Math.min(totalIds - 1, activeIdx + 1);
        }

        break;

      case HOME:
        // Prevent page scroll
        event.preventDefault();
        newActiveIdx = 0;
        break;

      case END:
        // Prevent page scroll
        event.preventDefault();
        newActiveIdx = totalIds - 1;
        break;
    }

    if (newActiveIdx >= 0) {
      callback && callback(itemIds[newActiveIdx], event);
    }
  }, [activeItemId, cycle, itemIds, callback]);
  return {
    onKeyDown: onKeyDown
  };
};

var _default = useListSelectionKeyboardActions;
exports.default = _default;